import { render } from "./numberCell.vue?vue&type=template&id=64d88f13&scoped=true"
import script from "./numberCell.vue?vue&type=script&lang=js"
export * from "./numberCell.vue?vue&type=script&lang=js"

import "./numberCell.vue?vue&type=style&index=0&id=64d88f13&scoped=true&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64d88f13"]])

export default __exports__